<div class="new-content" *ngIf="!pane else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>

<ng-template #contentBlock>
  <section class="services-drag-scroll">
    <ng-template [ngIf]="!pane.infinity" [ngIfElse]="infinity">
      <div class="pane-header" [class.mobile]="deviceService.isMobile()">
        <app-library-title [title]="blockTitle" [class.with-sorting]="_pane.show_sorting">
          <ng-template [ngIf]="false">
            <ng-container side>
              <div class="tab-filter">
                <ul class="tabs">
                  <li *ngFor="let filter of filters; let i = index; trackBy: trackByFn" class="tab normal"
                      [class.active]="i === indexFilterSelected"
                      (click)="selectFilter(i)">
                    {{ (display(filter) | typeof) === 'string' ?
                    (display(filter) | customLocale) : (display(filter) | dfnsFormat: 'd MMMM') }}
                  </li>
                </ul>
              </div>
            </ng-container>
          </ng-template>
        </app-library-title>
        <app-library-sorting *ngIf="_pane.show_sorting" [class.with-more]="blockTitle?.see_all_link" [pane]="_pane"></app-library-sorting>
      </div>
      <ng-template [ngIf]="userServices && userServices.length > 0">
        <ng-template [ngIf]="isDragScrollEnabled && isBrowser" [ngIfElse]="responsiveScroll">
          <div class="carousel">
            <ng-template [ngIf]="chunk(userServices, rows()).length > this.cardSizeTable?.min_units">
              <div class="right-btn" (click)="moveRight()">
                <app-icon class="right-arrow" icon="drag-scroll-arrow"></app-icon>
              </div>

              <div class="left-btn" (click)="moveLeft()">
                <app-icon class="left-arrow" icon="drag-scroll-arrow"></app-icon>
              </div>
            </ng-template>

            <cdk-virtual-scroll-viewport #scroller
                                         [itemSize]="cardSizeTable.width"
                                         [style.height.px]="cardSizeTable.height * rows() + 30"
                                         class="scroll-viewport"
                                         orientation="horizontal">
              <div *cdkVirtualFor="let service_chunk of chunk(userServices, rows()); let i = index; trackBy: trackByFn"
                   class="scroll-item"
                   [style.width.px]="cardSizeTable.width">
                <div class="column">
                  <div *ngFor="let service of service_chunk; let i = index; trackBy: trackByFn" class="card-wrap">
                    <app-user-service-card [service]="service"
                                             [displayMode]="userServicesView()"
                                             (openUserServiceInModal)="onToggleUserServiceInModal($event)">
                    </app-user-service-card>
                  </div>
                </div>
              </div>
            </cdk-virtual-scroll-viewport>
          </div>
        </ng-template>

        <ng-template #responsiveScroll>
          <div class="responsive-scroll-viewport">
            <div *ngFor="let service_chunk of chunk(userServices, rows()); let i = index; trackBy: trackByFn"
                 class="scroll-item"
                 [style.min-width.px]="cardSizeTable.width"
                 [style.width.px]="cardSizeTable.width">
              <div class="column">
                <div *ngFor="let service of service_chunk; let i = index; trackBy: trackByFn" class="card-wrap">
                  <app-user-service-card [service]="service"
                                           [displayMode]="userServicesView()"
                                           (openUserServiceInModal)="onToggleUserServiceInModal($event)">
                  </app-user-service-card>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-template>
    </ng-template>

    <ng-template #infinity>
      <div class="pane-header" [class.mobile]="deviceService.isMobile()">
        <app-library-title [title]="blockTitle" [class.with-sorting]="_pane.show_sorting"></app-library-title>
        <app-library-sorting *ngIf="_pane.show_sorting" [class.with-more]="blockTitle?.see_all_link" [pane]="_pane"></app-library-sorting>
      </div>
      <div class="infinity-content-cards">
        <div *ngFor="let item of userServices; let i = index; trackBy: trackByFn" class="infinity-item">
          <app-user-service-card [service]="item"
                                   [displayMode]="userServicesView()"
                                   (openUserServiceInModal)="onToggleUserServiceInModal($event)">
          </app-user-service-card>
        </div>
      </div>

      <loading-line *ngIf="pane.loading" height="40px" width="100%"></loading-line>
      <span inViewport (inViewportAction)='onInViewportBottomChange($event)'></span>
    </ng-template>
  </section>
</ng-template>

<app-modal *ngIf="deviceService.isDesktop() && userServiceCardFullInModal"
           [canClose]="false"
           (closed)="onToggleUserServiceInModal()">
  <app-modal-body>
    <app-user-service-card-full [userService]="openedUserService"
                                [modal]="true"
                                (inViewportChange)="onIinViewportChange($event)">
    </app-user-service-card-full>
  </app-modal-body>
  <app-modal-ad>
    <ng-template [ngIf]="!surfaceBlockDisplay">
      <app-user-service-surface-block [userService]="openedUserService"></app-user-service-surface-block>
    </ng-template>
  </app-modal-ad>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop() && userServiceCardFullInModal"
                  [titleVisible]="true"
                  (closed)="onToggleUserServiceInModal()">
  <app-mobile-modal-body>
    <app-user-service-card-full [userService]="openedUserService"
                                [modal]="true"
                                (inViewportChange)="onIinViewportChange($event)">
    </app-user-service-card-full>
  </app-mobile-modal-body>
  <app-mobile-modal-ad>
    <ng-template [ngIf]="!surfaceBlockDisplay">
      <app-user-service-surface-block [userService]="openedUserService"></app-user-service-surface-block>
    </ng-template>
  </app-mobile-modal-ad>
</app-mobile-modal>
